import { getNameText, PatientStatusCode } from '@quromedical/fhir-common';
import type { Gender, PersonGeneral } from '@quromedical/models';
import { getAgeInYears } from 'helpers';
import { strings } from 'strings';

export const patientStatusDisplay: Record<PatientStatusCode, string> = {
  [PatientStatusCode.Admitted]: strings.AdmissionStatusAdmitted,
  [PatientStatusCode.Discharged]: strings.AdmissionStatusDischarged,
  [PatientStatusCode.Onboarded]: strings.AdmissionStatusOnboarded,
  [PatientStatusCode.Invalidated]: strings.AdmissionStatusInvalidated,
};

const genderRecordMapping: Record<Gender, string> = {
  female: 'F',
  male: 'M',
  other: 'O',
  unknown: 'U',
};

const genderMapping = (gender: Gender = 'unknown'): string =>
  (gender && genderRecordMapping[gender]) || 'U';

export const getNameAgeAndGender = (
  general: Partial<PersonGeneral> | undefined,
): string => {
  if (!general) {
    return '';
  }

  const gender = genderMapping(general.gender);
  const age = getAgeInYears(general.birthDate);
  const name = getNameText(general.givenName, general.familyName);

  return `${name} (${gender} / ${age})`;
};
